var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrice3Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd05e;}.cls-2{fill:#f7b64b;}.cls-3{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cout3_selected",
    "data-name": "cout3 selected"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.48,27.29A11.07,11.07,0,0,1,31.57,17a10.85,10.85,0,0,0-4-.75,11.07,11.07,0,1,0,4,21.39A11.07,11.07,0,0,1,24.48,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.48,27.29a11,11,0,0,1,3.43-8l-.3,0a8,8,0,1,0,0,16h.3A11,11,0,0,1,24.48,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.51,27.29A11.06,11.06,0,0,1,23.61,17a11,11,0,0,0-4-.75,11.07,11.07,0,1,0,4,21.39A11.06,11.06,0,0,1,16.51,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.51,27.29a11,11,0,0,1,3.43-8l-.3,0a8,8,0,1,0,0,16h.3A11,11,0,0,1,16.51,27.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.54,
    cy: 27.29,
    r: 11.06,
    transform: "translate(0.85 55.65) rotate(-76.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.54,
    cy: 27.29,
    r: 8.02,
    transform: "translate(0.84 55.64) rotate(-76.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrice3Selected);
export default __webpack_public_path__ + "static/media/icon_price_3_selected.af75cb9f6fd102f1664788a86e5ded87.svg";
export { ForwardRef as ReactComponent };